import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=29242a2b&scoped=true&"
import script from "./UserForm.vue?vue&type=script&lang=ts&"
export * from "./UserForm.vue?vue&type=script&lang=ts&"
import style0 from "./user-form.scss?vue&type=style&index=0&id=29242a2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29242a2b",
  null
  
)

export default component.exports